import CalculatorWindow from '@/components/CalculatorWindow/CalculatorWindow'
import { Typography } from '@/components/Typography'
import { Window } from '@/components/Window'

import Fih from '../../../assets/gifs/fih.gif'
import FreakyFih from '../../../assets/gifs/freaky-fih.gif'

import styles from './home.module.css'

export default function Home() {
  return (
    <div className={styles.page}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '15px',
        }}
      >
        <CalculatorWindow
          getResult={(numberx, numbery) => numbery * (numberx / 100)}
          title="calculate x% of y.exe"
          numberXLabel="Percentage"
          numberYLabel="Number"
        />
        <CalculatorWindow
          getResult={(numberx, numbery) => (numberx / numbery) * 100}
          title="calculate x is what % of y.exe"
          windowStyle={{ width: '300px' }}
          numberXLabel="Number X"
          numberYLabel="Number Y"
        />
        <CalculatorWindow
          getResult={(numberx, numbery) =>
            ((numbery - numberx) / numberx) * 100
          }
          title="calculate % of increase/decrease.exe"
          windowStyle={{ width: 'fit-content' }}
          numberXLabel="Number X"
          numberYLabel="Number Y"
        />
        <Window title="IMPORTANT.exe">
          <Typography variant="paragraph" pixelated>
            You are strong <br />
            You are capable <br />
            You are loved <br />
          </Typography>
        </Window>
      </div>
      <img
        src={Fih}
        style={{
          position: 'absolute',
          right: '20px',
          bottom: '20px',
          width: '200px',
        }}
      />
      <img
        src={FreakyFih}
        style={{
          position: 'absolute',
          right: '250px',
          bottom: '90px',
          width: '200px',
        }}
      />
    </div>
  )
}
